import { Controller } from "@hotwired/stimulus"

// Click anywhere on the <tr> → Turbo-visit hrefValue. Skips clicks
// originating from interactive elements so users can still tick the
// row checkbox, click the name link, or interact with embedded inputs.
export default class extends Controller {
  static values = { href: String }

  initialize() { this.click = this.click.bind(this) }
  connect()    { this.element.addEventListener("click", this.click) }
  disconnect() { this.element.removeEventListener("click", this.click) }

  click(event) {
    if (event.target.closest("a, button, input, select, details, summary, label, [data-no-row-link]")) return
    if (!this.hasHrefValue) return

    // A top-level Turbo.visit breaks out of any enclosing turbo-frame (the
    // upload-detail timecards panel is one), so the detail page replaces the whole
    // window rather than rendering inside the panel. `from` is the page we leave,
    // so the detail can link back (see safe_return_path).
    Turbo.visit(this.withReturnOrigin(this.hrefValue, window.location.pathname + window.location.search))
  }

  // Append the overview the user is leaving as `from`, so the detail page can
  // link back to the list (see safe_return_path). `origin` is captured at click
  // time so it reflects the current filter even after Turbo advanced it. Generic
  // to every overview using row-link.
  withReturnOrigin(href, origin) {
    const separator = href.includes("?") ? "&" : "?"
    return `${href}${separator}from=${encodeURIComponent(origin)}`
  }
}
